import { createGlobalStyle } from 'styled-components'

import './fonts.css'

export default createGlobalStyle``
